<svelte:options
  customElement={{
    tag: "oc-action-signifier-v1",
    /*                       */
    extend: window.__components.extend(),
    props: {
      label: { type: "String", attribute: "label" },
      inverted: { type: "Boolean", attribute: "inverted" },
      variant: { type: "String", attribute: "variant" },
    },
  }}
/>

<script lang="ts">
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { label = undefined, inverted = false, variant = "icon" } = $props();
</script>

<div class="action-signifier">
  {#if variant === "text"}
    <span class={`action-signifier__text ${inverted ? "action-signifier__text--inverted" : ""}`}>
      {label}
    </span>
    <div
      class={`action-signifier__text-icon  ${inverted ? "action-signifier__text-icon--inverted" : ""}`}
    >
      <oc-icon-v1 type="arrow-right" size={/*                      */ "50"}></oc-icon-v1>
    </div>
  {/if}

  {#if variant === "icon"}
    <div class={`action-signifier__icon ${inverted ? "action-signifier__icon--inverted" : ""}`}>
      <oc-icon-v1 type="arrow-right" size={/*                      */ "100"}></oc-icon-v1>
    </div>
  {/if}
</div>

<DefaultStyles />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  :global {
    :host {
      display: block;
    }

    .action-signifier {
      color: tokens.$oc-component-action-signifier-text-text-color;
      display: flex;
      align-items: center;
      gap: tokens.$oc-component-action-signifier-text-gap-x;

      /*                                       */
      &__text {
        font: tokens.$oc-component-action-signifier-text-font;

        &--inverted {
          color: tokens.$oc-component-action-signifier-inverted-text-color;
          text-decoration: underline;
        }
      }

      &__text-icon {
        color: tokens.$oc-component-action-signifier-text-text-color;
        line-height: 0;

        &--inverted {
          color: tokens.$oc-component-action-signifier-inverted-icon-color;
        }
      }

      /*                                */
      &__icon {
        line-height: 0;
        color: tokens.$oc-component-action-signifier-icon-icon-color;

        &--inverted {
          color: tokens.$oc-component-action-signifier-inverted-icon-color;
        }
      }
    }
  }
</style>
